<!--
 * @Descripttion: 
 * @FilePath: /mall-wap-vue/src/views/login/components/PageTitle/index.vue
 * @Author: 张兴业
 * @Date: 2020-09-30 11:55:26
 * @LastEditors: 张兴业
 * @LastEditTime: 2020-10-10 10:35:14
-->
<template>
  <div class="login_title">
    {{ title }}
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="less" scoped>
.login_title {
  padding-top: 30px;
  text-align: center;
  font-size: 24px;
  font-weight: 400;
}
</style>
